export const Events = {
  SET_USER: "SET_USER",
  SET_MAIN_POOL: "SET_MAIN_POOL",
  SET_RESULTS: "SET_RESULTS",
  SET_USERS_STATUS: "SET_USERS_STATUS",
  SET_SESSION: "SET_SESSION",
  SET_IS_LOADING: "SET_IS_LOADING",
};
